import { withInstall } from '@jdesign-vue/utils'

import Guide from './src/guide.vue'
import GuideHint from './src/guide-hint.vue'

export const JdGuide = withInstall(Guide)
export const JdGuideHint = withInstall(GuideHint)

export default JdGuide

export * from './src/guide'
export * from './src/guide-hint'
